const PromptTarget = {
  BROWSE: 'browse',
  CHECKOUT: 'checkout',
} as const;

export default PromptTarget;
